<template>
  <div class="cert-list-item-version-badge">
    <p class="cert-list-item-version-badge__version">{{ version }}</p>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
  name: 'CertificationsListItemVersionBadge',
  props: {
    versions: {
      type: Array,
      required: true,
    },
    latestVersion: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    version() {
      const { versions, latestVersion, status } = this
      if (versions?.length && versions[versions.length - 1].is_beta)
        return 'BETA'
      if (status === CONSTANTS.CERTIFICATIONS.STATUS.COMING_SOON) {
        const version = CONSTANTS.CERTIFICATIONS.STATUS.COMING_SOON.replace(
          /_/g,
          ' '
        )
        return version.charAt(0).toUpperCase() + version.slice(1)
      }

      return `v${latestVersion}`
    },
  },
}
</script>

<style lang="scss">
.cert-list-item-version-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--glass-dark);
  border-radius: 20px;
  color: var(--white);
  padding: 9px 14px;
  margin: 0 0 10px 0;
  font-size: rem(12);
  line-height: 14px;
  &__version {
    margin: 0;
    padding: 0;
  }
}
</style>
